import { setCookie } from 'cookies-next'
import { distinctIdCookieKey } from '../../cookie-keys'

export function setDistinctId(distinctId: string) {
  setCookie(distinctIdCookieKey, distinctId)
}
